import type { Category } from "@/interface/category";

import type { MenuSnapshotProduct } from '../types/menu-snapshot';
import { getProductDisplayName } from './product-name';
import { shouldShowProduct } from "@/app/(users)/totem-by-slug/[slug]/utils/product-stock";

export function getProductsByCategory(products: MenuSnapshotProduct[], categoryId: string): MenuSnapshotProduct[] {
  return products
    .filter(product => shouldShowProduct(product) && product.product_category?.some(pc => pc.category_id === categoryId))
    .sort((a, b) => {
      const weightA = a.product_category?.find(pc => pc.category_id === categoryId)?.weight ?? 10;
      const weightB = b.product_category?.find(pc => pc.category_id === categoryId)?.weight ?? 10;
      if (weightA !== weightB) return Number(weightA) - Number(weightB);
      return getProductDisplayName(a).localeCompare(getProductDisplayName(b), 'es');
    });
}

export function sortCategories(categories: Category[]): Category[] {
  return [...categories].sort((a, b) => {
    const priorityDiff = (a.priority ?? 0) - (b.priority ?? 0);
    if (priorityDiff !== 0) return priorityDiff;
    return a.name.localeCompare(b.name, "es");
  });
}

export function productHasSubselections(product: MenuSnapshotProduct): boolean {
  if (
    !product.product_subselection ||
    product.product_subselection.length === 0
  )
    return false;

  return product.product_subselection.some(ps => {
    return (
      ps.subselection?.subselection_item?.some(item => {
        return item.product_stock?.stock !== 0;
      }) ?? false
    );
  });
}
